// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1M101","upload":"Small_upload__1hL1c","imageWrap":"Small_imageWrap__2IBaX","removeBtn":"Small_removeBtn__5iq5T"};